// extracted by mini-css-extract-plugin
export default {"root":"MenuSeparator-module__root"};